import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { dominioDemandaCirurgica } from '../../../../config/database';
import 'assets/css/geral.css';
import { PendenciasWizard, setPendencia } from '../../ValidacaoWizard';

const TextMaskCelularCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

const TextMaskTelefoneCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

TextMaskCelularCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskTelefoneCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class PacientePedidoPadrao extends Component {
  state = {
    informacoesPaciente: {},
    listaConvenio: [],
    convenio: null,
    peso: null,
    celular: null,
    telefone: null,
    email: null,
  };

  handleChange = name => e => {
    this.setState({
      [name]: e.target.value.replace(/[^0-9]/g, ''),
    });
    localStorage.setItem(name, e.target.value.replace(/[^0-9]/g, ''));
  };

  componentDidMount() {
    const paciente = localStorage.getItem('paciente');
    const convenio = localStorage.getItem('convenio');
    const peso = localStorage.getItem('peso');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

    if (paciente) {
      this.setState({
        informacoesPaciente: JSON.parse(paciente),
      });
    }

    if (convenio) this.setState({ convenio: JSON.parse(convenio) });
    if (peso) this.setState({ peso });

    dominioDemandaCirurgica.get('/api/convenio').then(response => {
      this.setState({ listaConvenio: response.data });
    });

    if (telefone) this.setState({ telefone });
    else if (paciente)
      this.setState({
        telefone: JSON.parse(paciente).TELEFONE ? `${JSON.parse(paciente).TELEFONE}` : '',
      });
    if (celular) this.setState({ celular });
    else if (paciente)
      this.setState({
        celular: JSON.parse(paciente).CELULAR ? `${JSON.parse(paciente).CELULAR}` : '',
      });
    if (email) this.setState({ email });
    else if (paciente) this.setState({ email: JSON.parse(paciente).EMAIL });

    dominioDemandaCirurgica
      .get(`/api/convenioPorCategoria/${configuracoes.categoriaConvenioPublico}`)
      .then(response => {
        this.setState({ listaConvenio: response.data });
      });
  }

  getSexo = () => {
    if (this.state.informacoesPaciente.COD_SEXO) {
      return this.state.informacoesPaciente.COD_SEXO === 'M' ? 'Masculino' : 'Feminino';
    }

    return null;
  };

  getDataNascimentoFormatada = () => {
    if (this.state.informacoesPaciente.DAT_NASCIMENTO) {
      const data = new Date(this.state.informacoesPaciente.DAT_NASCIMENTO);
      data.setDate(data.getDate() + 1);
      return data.toLocaleDateString('pt-BR');
    }

    return null;
  };

  render() {
    return (
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Dados do paciente</h3>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="prontuario"
              variant="outlined"
              fullWidth
              id="prontuario"
              label="Prontuário"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NRO_PRONTUARIO}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField
              autoComplete="off"
              name="nome"
              variant="outlined"
              fullWidth
              id="nome"
              label="Nome"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NOM_PESSOA}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="nascimento"
              variant="outlined"
              fullWidth
              id="nascimento"
              label="Nascimento"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getDataNascimentoFormatada()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="sexo"
              variant="outlined"
              fullWidth
              id="sexo"
              label="Sexo"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getSexo()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="telefone"
              label="Telefone"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.telefone}
              InputProps={{
                inputComponent: TextMaskTelefoneCustom,
                onChange: this.handleChange('telefone'),
              }}
              onBlur={() => {
                if (this.state.telefone) {
                  const array = Array.from(this.state.telefone.split(' '));
                  const index = array.length - 1;
                  if (
                    array[index].toString().startsWith('149') ||
                    array[index].toString().startsWith('148') ||
                    array[index].toString().startsWith('9') ||
                    array[index].toString().startsWith('8')
                  ) {
                    alert('Número de telefone inválido');
                    this.setState({ telefone: '' });
                    localStorage.setItem('telefone', null);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="celular"
              label="Celular"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.celular}
              InputProps={{
                inputComponent: TextMaskCelularCustom,
                onChange: this.handleChange('celular'),
              }}
              onBlur={() => {
                if (this.state.celular) {
                  const array = Array.from(this.state.celular.split(' '));
                  const index = array.length - 1;
                  if (
                    array[index].toString().startsWith('143') ||
                    array[index].toString().startsWith('3')
                  ) {
                    alert('Número de celular inválido');
                    this.setState({ celular: '' });
                    localStorage.setItem('celular', null);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              id="email"
              label="Email"
              InputLabelProps={{ shrink: true }}
              value={this.state.email}
              onChange={e => {
                localStorage.setItem('email', e.target.value);
                this.setState({ email: e.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="peso"
              type="number"
              variant="outlined"
              fullWidth
              id="peso"
              InputLabelProps={{ shrink: true }}
              label="Peso"
              value={this.state.peso}
              maxLength="4"
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = 0;
                }
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.substring(0, 6);
                }
                localStorage.setItem('peso', e.target.value);
                this.setState({ peso: e.target.value });
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Autocomplete
              id="convenio"
              options={this.state.listaConvenio}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              value={this.state.convenio}
              onChange={(e, values) => {
                localStorage.setItem('convenio', JSON.stringify(values));
                this.setState({ convenio: values });

                setPendencia(0, PendenciasWizard.convenio);
              }}
              renderInput={params => <TextField {...params} label="Convênio" variant="outlined" />}
            />
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default PacientePedidoPadrao;
